import { Engine } from "json-rules-engine"

class JsonEngine extends Engine {
  constructor({ rules }) {
    super(rules)
  }

  static getInstance({ rules }) {
    if (!JsonEngine.instance) {
      JsonEngine.instance = new JsonEngine({ rules })
      this.configurateUserPermissionRules()
    }
    return JsonEngine.instance
  }
  
  static configurateUserPermissionRules() {
    this.instance?.addOperator("empty", (factValue) => {
      return !factValue || (factValue && factValue.length === 0)
    })
    this.instance?.addOperator("notExistsOrWithValue", (factValue, jsonValue) => {
      return !factValue || factValue.toString() === jsonValue
    })
    this.instance?.addOperator(
      "inGroups",
      (factValue, userGroups) => {
        return (
          factValue &&
          userGroups &&
          userGroups
            .map((group) => {
              return group.id
            })
            .indexOf(factValue[0]) >= 0
        )
      },
    )
    this.instance?.addOperator(
      "groupContains",
      (userGroups, groupToSearchStr) => {
        return (
          groupToSearchStr &&
          userGroups &&
          userGroups
            .map((group) => {
              return group.id
            })
            .indexOf(groupToSearchStr) >= 0
        )
      },
    )
  }

  static clear() {
    this.instance = null
  }
}
export default JsonEngine
